module.exports = __webpack_public_path__ + "static/img/brees-2004-slide-5.0661e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-slide-5.jpg
// module id = dJ5g
// module chunks = 1